<template>
  <section>
    <!-- Listing Header -->
    <components-header @search="search" @add="addComponent" />
    <!-- Listing -->
    <div class="custom-wrapper">
      <div class="custom-add"></div>
      <z-table
        :value="dashboardComponents"
        :columns="tableColumns"
        :isSingleRowDetail="false"
        class="table table-bordered table-striped"
        detailColumnClass="z-column-60-center"
        @sort="setOrder"
        :loading="isLoading"
      >
        <template v-slot:tbody="props">
          <th scope="row" class="z-column-60-center">{{ props.row.id }}</th>
          <td class="z-column-60-center">
            <a href="#" @click="getComponent(props.row)">edit</a>
          </td>
          <td>{{ props.row.name }}</td>
          <td class="z-column-60-center">{{ props.row.target }}</td>
          <td><a href="#" @click="confirmRemoval(props.row.id)">remove</a></td>
        </template>
        <template v-slot:empty> Nothing found! </template>
      </z-table>
    </div>
    <component-dialog
      id="component-modal"
      :show="actionComponent"
      @close="closeModal"
      @saved="savedComponent"
    />
    <confirm-delete
      :show="actionDelete"
      :confirmTitle="confirmTitle"
      :confirmAction="confirmAction"
      :confirmQuestion="confirmQuestion"
      @closing="closeModal"
      @proceed="performDeletion"
    />
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ZTable from '@/Components/ZElements/Table'
import ComponentsHeader from '@/Components/DashboardComponents/components-header'
import ComponentDialog from '@/Components/DashboardComponents/forms/component-dialog'
import ConfirmDelete from '@/Components/ZElements/ConfirmDialog'
export default {
  name: 'components-listing',
  components: {
    ZTable,
    ComponentsHeader,
    ComponentDialog,
    ConfirmDelete,
  },
  data() {
    return {
      page: 1,
      actionComponent: null,
      isLoading: false,
      showSpin: null,
      currentId: null,
      confirmTitle: 'Remove Component',
      confirmAction: 'Remove',
      confirmQuestion: 'Are you sure you wish to Remove this Component',
      actionDelete: null,
    }
  },
  async mounted() {
    this.isLoading = false
    this.currentId = null
    this.setPager({
      name: 'page',
      value: 1,
    })
    this.setPager({
      name: 'search',
      value: '',
    })
    await this.search()
  },
  computed: {
    ...mapGetters('organizations', ['examineOrganization']),
    ...mapGetters('dashboardComponents', [
      'dashboardComponents',
      'dashboardComponent',
      'pager',
    ]),
    tableColumns() {
      return [
        {
          field: 'id',
          label: 'Id',
          sortable: false,
          class: 'z-column-60-center',
        },
        {
          field: 'id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        },
        { field: 'name', label: 'Name', sortable: false },
        {
          field: 'target',
          label: 'Target',
          sortable: false,
          class: 'z-column-60-center',
        },
        {
          field: 'id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        },
      ]
    },
  },
  methods: {
    ...mapActions('dashboardComponents', [
      'getComponents',
      'editComponent',
      'resetComponent',
      'setComponentData',
      'removeComponent',
      'setPager',
    ]),
    closeModal() {
      this.actionComponent = null
      this.actionDelete = null
    },
    async setOrder(column, order) {
      this.setPager({
        name: 'sortBy',
        value: column.field,
      })
      this.setPager({
        name: 'orderBy',
        value: order,
      })
      await this.search()
    },
    async search() {
      try {
        await this.getComponents({
          page: this.pager.page,
          pageSize: this.pager.pageSize,
          sortBy: this.pager.sortBy,
          orderBy: this.pager.orderBy,
          search: this.pager.search,
          orgId: this.examineOrganization.id,
        })
        window.app.$forceUpdate()
      } catch (e) {
        console.log('Error', e)
      }
    },
    async addComponent() {
      let data = {
        id: null,
        name: null,
        orgId: this.examineOrganization.id,
      }
      this.resetComponent(data)
      this.actionComponent = {
        isAdd: true,
        data: data,
      }
    },
    async getComponent(row) {
      let data = {
        id: row.id,
        name: row.name,
        orgId: this.examineOrganization.id,
      }
      await this.editComponent(data.id)
      this.actionComponent = {
        isAdd: false,
        data: data,
      }
    },
    async savedComponent() {
      this.closeModal()
      await this.search()
    },
    confirmRemoval(id) {
      this.currentId = id
      console.log('Confirm Removal', id)
      this.actionDelete = true
    },
    async performDeletion() {
      await this.removeComponent(this.currentId)
      this.actionDelete = null
      await this.search()
    },
  },
}
</script>
<style lang='scss'>
.custom-wrapper {
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
}

.column-header {
  height: 2em;
  line-height: 2em;
  position: relative;
}
.cursor {
  cursor: pointer;
}
.sort-base {
  color: #ddd;
}
.row-highlight {
  cursor: pointer;
}
.table-row-center {
  text-align: center;
}
.custom-add {
  position: absolute;
  top: 9px;
  left: 8px;
}
.custom-lines {
  position: relative;
  text-align: center;
  margin: 0 auto;
  color: #0d6efd;
  cursor: grab;
}
</style>
